export enum ITipo_Campo {
  text = 1,
  check = 2,
  user = 3,
  none = 4,
  button = 5,
  combo = 6,
  label = 7,
  key = 7,
  multiline = 8,
  date = 9,
  hour = 10,
  multicheck = 11,
  multiuser = 12,
  userexternal = 13,
  userinternal = 14,
}

export const dictionaryType = (tipo: number) => {
  let value = "";
  switch (tipo) {
    case 1:
      value= "text";
      break;
    case 2:
      value= "check";
      break;
    case 3:
      value= "user";
      break;
    case 4:
      value= "none";
      break;
    case 5:
      value= "button";
      break;
    case 6:
      value= "combo";
      break;
    case 7:
      value= "label";
      break;
    case 8:
      value= "multiline";
      break;
    case 9:
      value= "date";
      break;
    case 10:
      value= "hour";
      break;
    case 11:
      value= "multicheck";
      break;
    case 12:
      value= "multiuser";
      break;
    case 13:
      value= "userexternal";
      break;
    case 14:
      value= "userinternal";
      break;
  }

  return value;
}

interface FormValidation {
  flag: boolean;
  columns: Array<any>;
}export function formValidation(
  values: Array<React.RefObject<HTMLInputElement>>,
): boolean {
  let flag = true;

  values.forEach((c) => {
    if (!c.current?.value) {
      flag = false;
      c.current?.classList.add("error");
    } else {
      c.current?.classList.remove("error");
    }
  });
  return flag;
}
export function formValidationColumns(
  columnsDef: Array<any>,
  arrayValues: any
): FormValidation {
  let flag = true;
  let nColumns = columnsDef;

  nColumns.forEach((c) => {
    if (c.required && !arrayValues[c.id]) {
      flag = false;
      c.errorEmpty = true;
    } else {
      c.errorEmpty = false;
    }
  });
  return { flag: flag, columns: nColumns };
}
